var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecents = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16zM9.553 22.447a1.778 1.778 0 0 1 0-2.514l4.67-4.67V6.452a1.778 1.778 0 1 1 3.555 0V16l-.52 1.257-5.191 5.19a1.778 1.778 0 0 1-2.514 0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecents);
export default ForwardRef;